import { backendApi } from "@/services/backend/api";
import { UUID } from "@bitory-gmbh/nidavellir";
import { Filter } from "@/shared/lib/filter/filter";
import { Delivery, Item } from "@/services/backend/samples/types/delivery";
import { OrdrBy } from "@/shared/lib/ordr/ordrBy";
import { Lst } from "@/shared/lib/lst/lst";

const sampleDeliveryApi = backendApi
  .enhanceEndpoints({
    addTagTypes: ["SamplesDelivery"],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      samplesDeliveryShow: build.query<Delivery, ShowRequest>({
        query: (request) => ({
          url: `/samples/delivery`,
          method: "GET",
          params: request,
        }),
        providesTags: ["SamplesDelivery"],
      }),
      samplesDeliveryPut: build.mutation<Delivery, PutRequest>({
        query: (request) => ({
          url: `/samples/delivery`,
          method: "PUT",
          body: request,
        }),
        invalidatesTags: (_result, _e, request) => [
          { type: "SamplesDelivery", id: request.id },
          "SamplesDelivery",
          "SamplesSampleViewModel",
        ],
      }),
      samplesDeliveryCancel: build.mutation<Delivery, CancelRequest>({
        query: (request) => ({
          url: `/samples/delivery/cancel`,
          method: "PATCH",
          body: request,
        }),
        invalidatesTags: (_result, _e, request) => [
          { type: "SamplesDelivery", id: request.id },
          "SamplesDelivery",
          "SamplesSampleViewModel",
        ],
      }),
      samplesDeliverySend: build.mutation<Delivery, SendRequest>({
        query: (request) => ({
          url: `/samples/delivery/send`,
          method: "PATCH",
          body: request,
        }),
        invalidatesTags: (_result, _e, request) => [
          { type: "SamplesDelivery", id: request.id },
          "SamplesDelivery",
          "SamplesSampleViewModel",
        ],
      }),
      samplesDeliveryList: build.query<Lst<Delivery>, ListRequest>({
        query: (request) => ({
          url: `/samples/delivery/list`,
          method: "GET",
          params: {
            request: btoa(JSON.stringify(request)),
          },
        }),
        providesTags: ["SamplesDelivery"],
      }),
    }),
  });

export const {
  useSamplesDeliveryShowQuery,
  useSamplesDeliveryPutMutation,
  useSamplesDeliveryCancelMutation,
  useSamplesDeliverySendMutation,
  useSamplesDeliveryListQuery,
} = sampleDeliveryApi;

export interface ShowRequest {
  id: string;
}

export interface PutRequest {
  id: string;
  documentId: string;
  documentNamespace: string;
  trackingId: string;
  description: string;
  labId: string | null;
  items: Item[];
}

export interface CancelRequest {
  id: string;
}

export interface SendRequest {
  id: string;
}

export interface ListRequest {
  document?: Filter<UUID>;
  laboratory?: Filter<UUID>;
  trackingId?: Filter<string>;
  orderBy?: OrdrBy<"id" | "trackingId" | "laboratory">[];
  limit?: number;
  offset?: number;
}
